import Vue from 'vue'

export const getCompetencyTest = () => Vue.axios.get('surveys/comptest')
export const evaluateCompetencyTest = data => Vue.axios.post('surveys/comptest/eval', data)
export const getEvaluations = () => Vue.axios.get('surveys/comptest/evals')



// WEBPACK FOOTER //
// ./src/services/surveys.js